import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-with-tooltip',
  templateUrl: './text-with-tooltip.component.html',
  styleUrls: ['./text-with-tooltip.component.scss']
})
export class TextWithTooltipComponent implements OnInit {
  @Input() text!: string;
  showTooltip: boolean = true;

  @HostListener('window:resize', ['$event']) onResize() {
    this.detectTooltip();
  }

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.detectTooltip();
  }

  detectTooltip() {
    setTimeout(() => {
      const valueWidth = this.el.nativeElement.querySelector('.text-wrap').offsetWidth;
      const valueFullWidth = this.el.nativeElement.querySelector('.text-line').offsetWidth;

      this.showTooltip = valueFullWidth > valueWidth;
    });
  }
}
